export const DEMO_SUNBURST_DATA = {
  id: 'root',
  label: 'LIST Eco 360°',
  children: [
    {
      id: 'beraten',
      label: 'Beraten',
      children: [
        { id: 'esg', label: 'ESG & Reporting', info: {
            eyebrow: 'Kompetenzbereich', title: 'ESG & Reporting', itemsLabel: 'Leistungen',
            items: [{ label: 'CSRD-Berichterstattung', href: '#' }, { label: 'EU-Taxonomie', href: '#' }, { label: 'Doppelte Wesentlichkeitsanalyse', href: '#' }] } },
        { id: 'strategie', label: 'Nachhaltigkeits­strategie', info: {
            eyebrow: 'Kompetenzbereich', title: 'Nachhaltigkeitsstrategie', itemsLabel: 'Leistungen',
            items: [{ label: 'Zielbild & Roadmap', href: '#' }, { label: 'Dekarbonisierungspfad', href: '#' }, { label: 'Stakeholder-Dialog', href: '#' }] } },
        { id: 'quartier', label: 'Quartier & Stadt', info: {
            eyebrow: 'Kompetenzbereich', title: 'Quartier & Stadt', itemsLabel: 'Leistungen',
            items: [{ label: 'Quartierskonzepte', href: '#' }, { label: 'Mobilitätskonzepte', href: '#' }, { label: 'Wärmeplanung', href: '#' }] } },
        { id: 'esgdd', label: 'ESG Due Diligence', info: {
            eyebrow: 'Kompetenzbereich', title: 'ESG Due Diligence', itemsLabel: 'Leistungen',
            items: [{ label: 'Portfolio-Screening', href: '#' }, { label: 'Transaktionsbegleitung', href: '#' }, { label: 'Risikobewertung', href: '#' }] } },
        { id: 'betrieb', label: 'Betrieb & Monitoring', info: {
            eyebrow: 'Kompetenzbereich', title: 'Betrieb & Monitoring', itemsLabel: 'Leistungen',
            items: [{ label: 'Energiemonitoring', href: '#' }, { label: 'Betriebsoptimierung', href: '#' }, { label: 'Verbrauchsdatenmanagement', href: '#' }] } }
      ]
    },
    {
      id: 'planen',
      label: 'Integrales Planen und Zertifizieren',
      children: [
        { id: 'bauphysik', label: 'Bauphysik', info: {
            eyebrow: 'Kompetenzbereich', title: 'Bauphysik', itemsLabel: 'Leistungen',
            items: [{ label: 'Wärmeschutz', href: '#' }, { label: 'Schallschutz', href: '#' }, { label: 'Brandschutz', href: '#' }] } },
        { id: 'simulation', label: 'Simulation & Komfort', info: {
            eyebrow: 'Kompetenzbereich', title: 'Simulation & Komfort', itemsLabel: 'Leistungen',
            items: [{ label: 'Thermische Gebäudesimulation', href: '#' }, { label: 'Strömungssimulation', href: '#' }, { label: 'Tageslicht', href: '#' }] } },
        { id: 'nachhaltiges-bauen', label: 'Nachhaltiges Bauen', info: {
            eyebrow: 'Kompetenzbereich', title: 'Nachhaltiges Bauen', itemsLabel: 'Leistungen',
            items: [{ label: 'Ökobilanzierung (LCA)', href: '#' }, { label: 'Lebenszykluskosten', href: '#' }, { label: 'Zirkuläres Bauen', href: '#' }] } },
        { id: 'zertifizierung', label: 'Zertifizierungen',
          info: { eyebrow: 'Kompetenzbereich', title: 'Zertifizierungen', itemsLabel: 'Leistungen',
            items: [{ label: 'DGNB', href: '#' }, { label: 'QNG', href: '#' },
                    { label: 'LEED', href: '#' }, { label: 'BREEAM', href: '#' }] },
          // Beispiel für eine dritte Ebene
          children: [
            { id: 'dgnb', label: 'DGNB', info: {
                eyebrow: 'Zertifikat', title: 'DGNB', itemsLabel: 'Leistungen',
                items: [{ label: 'Vorprüfung', href: '#' }, { label: 'Auditierung', href: '#' }, { label: 'Konformitätsprüfung', href: '#' }] } },
            { id: 'qng', label: 'QNG', info: {
                eyebrow: 'Zertifikat', title: 'QNG', itemsLabel: 'Leistungen',
                items: [{ label: 'QNG-PLUS', href: '#' }, { label: 'QNG-PREMIUM', href: '#' }] } },
            { id: 'leed', label: 'LEED', info: {
                eyebrow: 'Zertifikat', title: 'LEED', itemsLabel: 'Leistungen',
                items: [{ label: 'Gap-Analyse', href: '#' }, { label: 'Dokumentation', href: '#' }, { label: 'Einreichung', href: '#' }] } },
            { id: 'breeam', label: 'BREEAM', info: {
                eyebrow: 'Zertifikat', title: 'BREEAM', itemsLabel: 'Leistungen',
                items: [{ label: 'Assessor-Begleitung', href: '#' }, { label: 'Nachweisführung', href: '#' }] } }
          ] },
        { id: 'architektur', label: 'Architektur & Baukultur', info: {
            eyebrow: 'Kompetenzbereich', title: 'Architektur & Baukultur', itemsLabel: 'Leistungen',
            items: [{ label: 'Entwurf', href: '#' }, { label: 'Umbaukultur', href: '#' }, { label: 'Wettbewerbe', href: '#' }] } },
        { id: 'tga', label: 'Technische Gebäude­ausrüstung', info: {
            eyebrow: 'Kompetenzbereich', title: 'Technische Gebäudeausrüstung', itemsLabel: 'Leistungen',
            items: [{ label: 'Anlagenkonzept', href: '#' }, { label: 'Erneuerbare Wärme', href: '#' }, { label: 'Ausführungsplanung', href: '#' }] } },
        { id: 'klima', label: 'Klimaanpassung & Biodiversität', info: {
            eyebrow: 'Kompetenzbereich', title: 'Klimaanpassung & Biodiversität', itemsLabel: 'Leistungen',
            items: [{ label: 'Hitze- & Starkregenvorsorge', href: '#' }, { label: 'Begrünungskonzepte', href: '#' }, { label: 'Biodiversitätsaudit', href: '#' }] } },
        { id: 'forschung', label: 'Forschung & Innovation', info: {
            eyebrow: 'Kompetenzbereich', title: 'Forschung & Innovation', itemsLabel: 'Leistungen',
            items: [{ label: 'Auftragsforschung', href: '#' }, { label: 'Antragsforschung', href: '#' }] } },
        { id: 'foerdermittel', label: 'Fördermittel', info: {
            eyebrow: 'Kompetenzbereich', title: 'Fördermittel', itemsLabel: 'Leistungen',
            items: [{ label: 'Förderkulisse-Analyse', href: '#' }, { label: 'Antragsmanagement', href: '#' }, { label: 'Verwendungsnachweis', href: '#' }] } }
      ]
    }
  ]
}
